import { Outlet } from 'react-router-dom';
import { OrgHostProvider } from '@/contexts/OrgHostContext';
import { OrgPublicProfileProvider } from '@/contexts/OrgPublicProfileContext';

/** Layout route that provides org host + public org profile to unified public pages. */
export function OrgHostOutlet() {
  return (
    <OrgHostProvider>
      <OrgPublicProfileProvider>
        <Outlet />
      </OrgPublicProfileProvider>
    </OrgHostProvider>
  );
}
